import React from "react";
import Header from "../components/Header";
import Footer from "../components/Footer";
import { Card, CardContent, CardHeader, CardTitle } from "../components/ui/card";
import Seo from "../components/Seo";
import AnnuaireFranceRenov from "../components/AnnuaireFranceRenov";

const MentionsLegales = () => {
  return (
    <div className="min-h-screen bg-white">
      <Seo
        titre="Mentions légales | Transition Énergie France"
        description="Mentions légales de Transition Énergie France, AMO agréé ANAH : éditeur, hébergeur et informations sur la société."
        chemin="/mentions-legales"
      />
      <Header />

      <main id="contenu">
      
      <section className="py-20 bg-gray-50">
        <div className="container mx-auto px-4">
          <div className="max-w-4xl mx-auto">
            <h1 className="text-4xl font-bold text-gray-900 mb-8 text-center">
              Mentions légales
            </h1>

            <div className="space-y-8">
              <Card>
                <CardHeader>
                  <CardTitle>Éditeur du site</CardTitle>
                </CardHeader>
                <CardContent className="space-y-4">
                  <div>
                    <p><strong>Raison sociale :</strong> Transition Énergie France</p>
                    <p><strong>Forme juridique :</strong> SAS (Société par actions simplifiée)</p>
                    <p><strong>Capital social :</strong> 5 000 €</p>
                    <p><strong>RCS :</strong> 880 084 694 R.C.S. Nanterre</p>
                    <p><strong>SIRET :</strong> 880 084 694 00046</p>
                    <p><strong>Adresse :</strong> 99 avenue Achille Peretti, 92200 Neuilly-sur-Seine</p>
                    <p><strong>Directeur de la publication :</strong> Jean Jacques Nini</p>
                    <p><strong>Téléphone :</strong> 09 39 03 54 44</p>
                    <p><strong>Email :</strong> amo@transition-energie-france.fr</p>
                  </div>
                </CardContent>
              </Card>

              {/* Assurance. La police couvre à la fois la RC décennale et la RC
                  professionnelle, mais TEF n'exécute pas les travaux : la décennale
                  qui protège le client sur un chantier est celle de l'artisan.
                  Les deux sont donc distinguées ici, volontairement.
                  Attestation MIC Insurance du 2026-04-03, valable jusqu'au
                  2026-09-30 — à renouveler à l'échéance du 1er octobre. */}
              <Card>
                <CardHeader>
                  <CardTitle>Assurance</CardTitle>
                </CardHeader>
                <CardContent className="space-y-4">
                  <div>
                    <p><strong>Assureur :</strong> MIC Insurance Company</p>
                    <p><strong>N° de police :</strong> AXE2405658</p>
                    <p>
                      <strong>Garanties :</strong> responsabilité civile professionnelle
                      des professions intellectuelles du bâtiment et responsabilité civile
                      décennale obligatoire
                    </p>
                  </div>
                  <p>
                    Cette police couvre Transition Énergie France au titre de son activité
                    d'assistance à maîtrise d'ouvrage et de bureau d'études. Les travaux
                    étant réalisés par des entreprises partenaires, la garantie décennale
                    applicable au chantier est celle souscrite par l'entreprise qui exécute
                    les travaux. Son attestation vous est communiquée avec son devis, et
                    nous vérifions sa validité avant le dépôt de votre dossier.
                  </p>
                </CardContent>
              </Card>

              <Card>
                <CardHeader>
                  <CardTitle>Hébergeur</CardTitle>
                </CardHeader>
                <CardContent>
                  <p><strong>Hébergeur :</strong> Hetzner Online GmbH</p>
                  <p><strong>Adresse :</strong> Industriestrasse 25, 91710 Gunzenhausen, Allemagne</p>
                  <p><strong>Téléphone :</strong> +49 (0)9831 505-0</p>
                </CardContent>
              </Card>

              <Card>
                <CardHeader>
                  <CardTitle>Propriété intellectuelle</CardTitle>
                </CardHeader>
                <CardContent className="space-y-4">
                  <p>
                    L'ensemble de ce site relève de la législation française et internationale 
                    sur le droit d'auteur et la propriété intellectuelle. Tous les droits de 
                    reproduction sont réservés, y compris pour les documents téléchargeables 
                    et les représentations iconographiques et photographiques.
                  </p>
                  <p>
                    La reproduction de tout ou partie de ce site sur un support quelconque, 
                    quel qu'il soit, est formellement interdite sauf autorisation expresse 
                    de Transition Énergie France.
                  </p>
                </CardContent>
              </Card>

              <Card>
                <CardHeader>
                  <CardTitle>Données personnelles</CardTitle>
                </CardHeader>
                <CardContent className="space-y-4">
                  <p>
                    Conformément à la loi n°78-17 du 6 janvier 1978 modifiée relative à 
                    l'informatique, aux fichiers et aux libertés et au Règlement Général 
                    sur la Protection des Données (RGPD), vous disposez d'un droit d'accès, 
                    de rectification, de suppression et d'opposition aux données personnelles 
                    vous concernant.
                  </p>
                  <p>
                    Pour exercer ces droits, vous pouvez nous contacter à l'adresse : 
                    amo@transition-energie-france.fr
                  </p>
                </CardContent>
              </Card>

              <Card>
                <CardHeader>
                  <CardTitle>Cookies</CardTitle>
                </CardHeader>
                <CardContent>
                  <p>
                    Ce site dépose uniquement les cookies nécessaires à son fonctionnement 
                    tant que vous n'avez pas donné votre accord. Les cookies de mesure d'audience 
                    (Google Analytics, PostHog) ne sont déposés qu'après votre consentement explicite, 
                    recueilli via le bandeau affiché lors de votre première visite. Vous pouvez 
                    retirer ou modifier votre choix à tout moment grâce au lien « Gérer mes cookies » 
                    situé en bas de chaque page.
                  </p>
                </CardContent>
              </Card>

              <Card>
                <CardHeader>
                  <CardTitle>Responsabilité</CardTitle>
                </CardHeader>
                <CardContent className="space-y-4">
                  <p>
                    Les informations contenues sur ce site sont données à titre indicatif 
                    et sont susceptibles d'évoluer. Transition Énergie France ne pourra 
                    être tenue responsable des dommages directs et indirects causés au 
                    matériel de l'utilisateur, lors de l'accès au site.
                  </p>
                  <p>
                    Transition Énergie France décline toute responsabilité quant au 
                    contenu des sites vers lesquels des liens hypertextes peuvent renvoyer 
                    à partir de son site.
                  </p>
                </CardContent>
              </Card>

              <Card>
                <CardHeader>
                  <CardTitle>MaPrimeAdapt' - Information légale</CardTitle>
                </CardHeader>
                <CardContent className="space-y-4">
                  <p>
                    <strong>Transition Énergie France</strong> est un Assistant à Maîtrise 
                    d'Ouvrage (AMO) agréé par l'Agence nationale de l'habitat (Anah) pour 
                    l'accompagnement dans le cadre du dispositif MaPrimeAdapt'.
                  </p>
                  <AnnuaireFranceRenov detaille />
                  <p>
                    L'accompagnement AMO est obligatoire pour bénéficier de MaPrimeAdapt' 
                    et est pris en charge intégralement par l'Anah (600€ à 800€ selon les cas).
                  </p>
                  <p>
                    Les travaux sont réalisés par notre réseau d'artisans partenaires 
                    labellisés RGE (Reconnu Garant de l'Environnement).
                  </p>
                  <p>
                    <strong>Zone d'intervention :</strong> Île-de-France - Départements 75, 77, 91, 92, 93, 95. 
                    Ouverture prévue : Yvelines (78), Val-de-Marne (94), Oise (60).
                  </p>
                </CardContent>
              </Card>
            </div>
          </div>
        </div>
      </section>

      </main>

      <Footer />
    </div>
  );
};

export default MentionsLegales;